import { createTheme } from '@material-ui/core/styles';

// Cores da empresa CiclusRio
const ciclusrioColors = {
  // Pantone 3435C - Verde escuro
  primary: '#12473F', // R18 G71 B63
  
  // Pantone 346C - Verde claro
  secondary: '#6FC496', // R111 G196 B150
  
  // Pantone 3425 - Verde médio escuro
  accent: '#036337', // R3 G99 B55
  
  // Pantone 339C - Verde azulado
  highlight: '#00B189', // R0 G177 B137
};

// Tema personalizado para CiclusRio
export const ciclusrioTheme = createTheme({
  palette: {
    primary: {
      main: ciclusrioColors.primary,
      light: ciclusrioColors.secondary,
      dark: ciclusrioColors.accent,
      contrastText: '#ffffff',
    },
    secondary: {
      main: ciclusrioColors.highlight,
      light: ciclusrioColors.secondary,
      dark: ciclusrioColors.accent,
      contrastText: '#ffffff',
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
    // Propriedades específicas do Backstage
    navigation: {
      background: ciclusrioColors.primary,
      indicator: ciclusrioColors.highlight,
      color: '#ffffff',
      selectedColor: ciclusrioColors.highlight,
    },
    // Outras propriedades necessárias
    error: {
      main: '#d32f2f',
    },
    warning: {
      main: '#ed6c02',
    },
    info: {
      main: '#0288d1',
    },
    success: {
      main: '#2e7d32',
    },
    text: {
      primary: '#000000',
      secondary: '#666666',
    },
  },
  overrides: {
    MuiDrawer: {
      paper: {
        backgroundColor: ciclusrioColors.primary,
        color: '#ffffff',
      },
    },
    MuiListItem: {
      root: {
        '&.Mui-selected': {
          backgroundColor: ciclusrioColors.highlight,
          '&:hover': {
            backgroundColor: ciclusrioColors.highlight,
            opacity: 0.9,
          },
        },
        '&:hover': {
          backgroundColor: '#ffffff', // Cor branca (cor atual do ícone/texto)
          transition: 'background-color 0.3s ease-in-out',
        },
      },
    },
    MuiListItemIcon: {
      root: {
        color: ciclusrioColors.highlight,
        '&:hover': {
          color: ciclusrioColors.primary, // Cor verde escuro (cor atual do fundo)
          transition: 'color 0.3s ease-in-out',
        },
      },
    },
    MuiListItemText: {
      primary: {
        color: ciclusrioColors.highlight,
        '&:hover': {
          color: ciclusrioColors.primary, // Cor verde escuro (cor atual do fundo)
          transition: 'color 0.3s ease-in-out',
        },
      },
    },
    MuiButton: {
      root: {
        '&:hover': {
          backgroundColor: '#ffffff', // Cor branca
          transition: 'background-color 0.3s ease-in-out',
        },
      },
      text: {
        '&:hover': {
          backgroundColor: '#ffffff', // Cor branca
          color: ciclusrioColors.primary, // Cor verde escuro
        },
      },
      contained: {
        '&:hover': {
          backgroundColor: '#ffffff', // Cor branca
          color: ciclusrioColors.primary, // Cor verde escuro
        },
      },
    },
    MuiIconButton: {
      root: {
        '&:hover': {
          backgroundColor: '#ffffff', // Cor branca
          color: ciclusrioColors.primary, // Cor verde escuro
          transition: 'all 0.3s ease-in-out',
        },
      },
    },
    MuiTypography: {
      h1: {
        color: ciclusrioColors.highlight,
      },
    },
    // Estilos específicos para componentes do Backstage - APENAS no hover - CORES INVERTIDAS
    MuiSvgIcon: {
      root: {
        '&:hover': {
          color: ciclusrioColors.primary, // Cor verde escuro (cor atual do fundo)
          transition: 'color 0.3s ease-in-out',
        },
      },
    },
  },
}); 